;(function ($) {
  "use strict"

  $(document).ready(function () {
    const notificationKey = "tei_notification"

    // Check if the notification has been closed before
    if (!sessionStorage.getItem(notificationKey)) {
      $(".notification").show()
    }

    $(".notification-close").on("click", function () {
      $(".notification").fadeOut(200, function () {
        // Save the closed state to sessionStorage
        sessionStorage.setItem(notificationKey, "true")
      })
    })
  })
})(jQuery)
